/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CanaleComunicazione } from './canale-comunicazione';


export interface GraduatoriaCanaliEsitoDTO { 
    /**
     * Canali abilitati e con testo per l\'evento GRADUATORIA_CAMBIO_STATO. Vuota se l\'evento non è configurato o se nessun canale è attivo.
     */
    canali?: Array<CanaleComunicazione>;
}

